// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__mVT_X","actionsCol":"EnrolledClinics_actionsCol__1s6sb"};